import axios from 'axios';
import { maybeConfirmResend, withConfirmCapable } from './athenaConfirm';

/**
 * v2 gateway client, used by the CareIQ chart tab and the website-requests
 * views (Communication > Appt Requests, Onboarding > Web Requests).
 *
 * hub.preview is a v1 app (api.js -> /ag, port 8001) and every other tab stays
 * there. The CareIQ tab was grafted from care, which is a v2 app, and several of
 * the routes it needs exist only on v2:
 *   /v1/fhir-mirror/...            (encounter, vitals, documents)
 *   /v1/{pid}/chart-preferences
 *   /v1/{pid}/claims/by-date
 *   /v1/{pid}/patients/.../documents/{cat}/{id}/summary
 * The rest of CareIQ's calls (kg/todo, labs, orders, user/config) are v1-only and
 * keep using api.js - CareIQTab imports both on purpose.
 *
 * Same JWT works on both gateways (shared SECRET_KEY), so this reuses the token
 * api.js puts in localStorage. Deliberately no refresh interceptor here: api.js
 * owns refresh, and two clients racing on it would double-refresh.
 */
const careiqapi = axios.create({
  baseURL: process.env.REACT_APP_API_V2_BASE || 'https://api.prd.brainymed.com/v2/ag',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

careiqapi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // document-filing routes: this client answers needs_confirm (./athenaConfirm.js)
    return withConfirmCapable(config);
  },
  (error) => Promise.reject(error)
);

// Match api.js: components receive the body, not the axios envelope.
// A 409 needs_confirm answer (Sync to Athena after an unanswered send) asks once and
// replays with ?confirm_resend=1 (./athenaConfirm.js, 2026-10-06).
careiqapi.interceptors.response.use(
  (response) => response.data,
  (error) => maybeConfirmResend(careiqapi, error) || Promise.reject(error)
);

export default careiqapi;
